/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const SetSessionLockdownDataParser = 
/* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('set')],
    ['maxEntries', codecNumber, 'max_entries'],
]);
export class SetSessionLockdownData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return SetSessionLockdownDataParser.decode(input).map(res => new SetSessionLockdownData(res));
    }
    static unsafeDecode(input) {
        return SetSessionLockdownData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return SetSessionLockdownDataParser.encode(data);
    }
    static schema() {
        return SetSessionLockdownDataParser.schema();
    }
}
